import { type MantineColor } from '@mantine/core';
import { TicketPriority, TicketStatus } from './model';

type TicketStatusMeta = Record<
    TicketStatus,
    {
        color: MantineColor;
        label: string;
    }
>;

export const ticketStatusMeta = {
    [TicketStatus.STATUS_UNSPECIFIED]: {
        color: 'gray.6',
        label: 'Не определен',
    },
    [TicketStatus.STATUS_CREATED]: {
        color: 'blue.5',
        label: 'Создан',
    },
    [TicketStatus.STATUS_RESOLVED]: {
        color: 'green.6',
        label: 'Решён',
    },
} as const satisfies TicketStatusMeta;

export const ticketStatusColors: Record<TicketStatus, MantineColor> = {
    [TicketStatus.STATUS_UNSPECIFIED]: ticketStatusMeta[TicketStatus.STATUS_UNSPECIFIED].color,
    [TicketStatus.STATUS_CREATED]: ticketStatusMeta[TicketStatus.STATUS_CREATED].color,
    [TicketStatus.STATUS_RESOLVED]: ticketStatusMeta[TicketStatus.STATUS_RESOLVED].color,
} as const;

export const ticketStatuses = [
    {
        value: TicketStatus.STATUS_CREATED,
        label: ticketStatusMeta[TicketStatus.STATUS_CREATED].label,
    },
    {
        value: TicketStatus.STATUS_RESOLVED,
        label: ticketStatusMeta[TicketStatus.STATUS_RESOLVED].label,
    },
] as const;

type TicketPriorityMeta = Record<
    TicketPriority,
    {
        color: MantineColor;
        label: string;
    }
>;

export const ticketPriorityMeta = {
    [TicketPriority.PRIORITY_UNSPECIFIED]: {
        color: 'gray.6',
        label: 'Не определен',
    },
    [TicketPriority.PRIORITY_HIGH]: {
        color: 'red.6',
        label: 'Высокий',
    },
    [TicketPriority.PRIORITY_MEDIUM]: {
        color: 'yellow.6',
        label: 'Средний',
    },
    [TicketPriority.PRIORITY_LOW]: {
        color: 'green.6',
        label: 'Низкий',
    },
} as const satisfies TicketPriorityMeta;

export const ticketPriorityColors: Record<TicketPriority, MantineColor> = {
    [TicketPriority.PRIORITY_UNSPECIFIED]: ticketPriorityMeta[TicketPriority.PRIORITY_UNSPECIFIED].color,
    [TicketPriority.PRIORITY_HIGH]: ticketPriorityMeta[TicketPriority.PRIORITY_HIGH].color,
    [TicketPriority.PRIORITY_MEDIUM]: ticketPriorityMeta[TicketPriority.PRIORITY_MEDIUM].color,
    [TicketPriority.PRIORITY_LOW]: ticketPriorityMeta[TicketPriority.PRIORITY_LOW].color,
} as const;

export const ticketPriorities = [
    {
        value: TicketPriority.PRIORITY_HIGH,
        label: ticketPriorityMeta[TicketPriority.PRIORITY_HIGH].label,
    },
    {
        value: TicketPriority.PRIORITY_MEDIUM,
        label: ticketPriorityMeta[TicketPriority.PRIORITY_MEDIUM].label,
    },
    {
        value: TicketPriority.PRIORITY_LOW,
        label: ticketPriorityMeta[TicketPriority.PRIORITY_LOW].label,
    },
] as const;
